<template>
    <form class="border rounded p-4 shadow-sm" @submit.prevent="handleFileUpload">
        <legend class="h5 fw-bold mb-4">
            Upload Bonus Points File
            <span class="text-muted ms-2">
                (Download Template:
                <a href="#" class="text-decoration-underline text-primary" @click.prevent="downloadCsvTemplate">here</a>)
            </span>
        </legend>

        <div class="mb-3">
            <label for="bonusFile" class="form-label">Select File</label>
            <input type="file" id="bonusFile" @change="onFileChange" accept=".csv" class="form-control" />
        </div>

        <button type="submit" class="btn btn-success">Submit</button>
    </form>
</template>

<style scoped>
form {
    width: 100%;
    margin: auto;
    background-color: #fff;
    border: 1px solid #ccc;
}

legend {
    color: #333;
}

.form-label {
    font-weight: 600;
}

.btn-success {
    background-color: #28a745;
    border-color: #28a745;
}

a.text-primary:hover {
    color: #0056b3;
    text-decoration: underline;
}

.shadow-sm {
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}
</style>

  
  
<script>
import DashboardService from "../../../../services/DashboardService"
export default {
    name: "BonusPointsUpload",
    data() {
        return {
            bonusFile: null, // Data property for the selected file
        };
    },
    methods: {
        onFileChange(event) {
            this.bonusFile = event.target.files[0];
        },
        handleFileUpload() {
            if (this.bonusFile) {
                const formData = new FormData();
                formData.append("file", this.bonusFile);

                console.log("FormData entries:");
                for (let [key, value] of formData.entries()) {
                    console.log(key, value); // This should show "file" and the file object details
                }
                DashboardService.addBonusPointData(formData)
                    .then((response) => {
                        if (response.status == 200) {
                            alert(`File uploaded successfully, Added bonus points for ${response.data.count} users`);
                        } else {
                            alert(response.data.error)
                        }
                    }).catch((e) => {
                        alert(e.response.data.message);
                    });
            } else {
                alert("Please select a file to upload.");
            }
        },
        downloadCsvTemplate() {
            // Define CSV headers
            const headers = ["UserID", "ClientID", "Points", "Txn Comments"];

            // Create CSV content
            const csvContent = headers.join(",") + "\n";

            // Create Blob and trigger download
            const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
            const link = document.createElement("a");
            const url = URL.createObjectURL(blob);

            link.href = url;
            link.download = "bonus_points_template.csv";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        }
    },
};
</script>
  